// extracted by mini-css-extract-plugin
export default {"root":"prices_root__bReWT","contain":"prices_contain__1MdTt","titre":"prices_titre__+4KoL","texte":"prices_texte__xxEHb","espace_haut":"prices_espace_haut__rrvDc"};